// @flow

const INITIAL_STATE = {
  applications: { rows: [], error: null, loading: false },
  application: { row: null, error: null, loading: false },
  current: { row: null, error: null, loading: false }
}

const application = (state: any = INITIAL_STATE, action: any) => {
  let error;
  switch(action.type) {

    // User's application
    case 'FETCH_USER_APP':
      return { ...state, application: { ...state.application, loading: true } };
    case 'FETCH_USER_APP_SUCCESS':
      return { ...state, application: { row: action.payload, error: null, loading: false } };
    case 'FETCH_USER_APP_FAILURE':
      error = action.payload || { message: action.payload };
      return { ...state, application: { row: null, error: error, loading: false } };
    case 'RESET_USER_APP':
      return { ...state, application: { row: null, error: false, loading: false } };

    // User's applications
    case 'FETCH_USER_APPS':
      return { ...state, applications: { rows: [], error: null, loading: true } };
    case 'FETCH_USER_APPS_SUCCESS':
      return { ...state, applications: { rows: action.payload, error: null, loading: false } };
    case 'FETCH_USER_APPS_FAILURE':
      error = action.payload || { message: action.payload };
      return { ...state, applications: { rows: [], error: error, loading: false } };
    case 'RESET_USER_APPS':
      return { ...state, applications: { rows: [], error: null, loading: false } };

    // Set global current application
    case 'SET_CURRENT_APPLICATION':
      return { ...state, current: { row: action.payload, error: null, loading: false } };

    case 'SET_APPLICATIONS':
      return { ...state, current: { row: action.payload, error: null, loading: false } };

    case 'SET_ACTIVE_APPLICATION':
      return { ...state, activeApplication: action.payload };

    // Reminder
    case 'UPDATE_REMINDES':
      return Object.assign({}, state, {
        activeApplication: Object.assign({}, state.activeApplication, {
          app_companies: state.activeApplication.app_companies.map((item) => {
            if (action.payload.indexOf(item.id) !== -1) {
              return Object.assign({}, item, {
                reminder_ws: {
                  ...item.reminder_ws,
                  count: ++item.reminder_ws.count,
                  last_sent: new Date(),
                }
              });
            };
            return item;
          })
        })
      })


    default:
      return state;
  }
}

export default application;



// WEBPACK FOOTER //
// ./src/reducers/application.js